/**
 * TOSS — Product Sustainability Index (from Hypes)
 * Central branding constants. All visual references should use this.
 *
 * IMPORTANT: This is a branding refresh only. All internal identifiers,
 * API contracts, calculation engines, route paths (`/basic/*`, `/advanced/*`),
 * localStorage keys (`upsi_mode`, `hypes_psi_token`) and result property
 * keys (`results.upsi`, etc.) are intentionally preserved.
 */

export const BRAND = {
  short: "TOSS",
  full: "Product Sustainability Index",
  from: "from Hypes",
  // Combined display string for hero / titles
  display: "TOSS — Product Sustainability Index",
  domain: "hypes.in",
  version: "v3.1.1",
};

// Official TOSS logo (provided by user)
export const TOSS_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_toss-minimal/artifacts/lfm62kkq_TOSSlogo.png";

// Legacy Hypes mark (kept for backwards compatibility in any place still
// referencing the previous LOGO_URL constant — replaced wherever visible).
export const LEGACY_HYPES_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_product-si-benchmark/artifacts/r3iqdih5_Logo%202-Photoroom.png";
